import { cifra, graficoAcumulado, tramo } from '../core/componentes.js';
import { balance, balanceAnual, contratosVisibles, importeDe } from '../core/dominio.js';
import { S } from '../core/estado.js';
import { anioActual, esc, eur, eurK, num } from '../core/formato.js';
import { db } from '../data/db.js';
import { tablaImputaciones } from './imputaciones.js';

/* =====================================================================
   INFORMES
   ===================================================================== */
function imputacionesFiltradas(){
  const cs = contratosVisibles().map(c=>c.id);
  let lista = db.imputaciones.filter(i=>cs.includes(i.contrato));
  if(S.infContrato!=='todos') lista = lista.filter(i=>i.contrato===S.infContrato);
  if(S.infCarretera!=='todos') lista = lista.filter(i=>i.carretera===S.infCarretera);
  if(S.infDesde) lista = lista.filter(i=>i.fecha>=S.infDesde);
  if(S.infHasta) lista = lista.filter(i=>i.fecha<=S.infHasta);
  return lista.slice().sort((a,b)=>b.fecha.localeCompare(a.fecha));
}

/* Reparto del importe filtrado agrupado por un campo (carretera, destino…),
   misma tabla con barra de distribución para ambos desgloses. */
function tablaPorCampo(lista, campo, defecto, titulo, sub, columna){
  const m={}; lista.forEach(i=>{ const k=i[campo]||defecto; m[k]=(m[k]||0)+importeDe(i); });
  const arr=Object.entries(m).sort((a,b)=>b[1]-a[1]);
  const max = arr.length?arr[0][1]:0;
  return `<div class="card" style="margin-top:16px"><div class="card-h"><div><h3>${titulo}</h3>
    <div class="sub">${sub}</div></div></div>
    <div class="tabla-wrap">${!arr.length?'<div class="vacio"><p>Sin datos.</p></div>':`<table><thead><tr><th>${columna}</th><th>Distribución</th><th class="num">Importe</th></tr></thead><tbody>
    ${arr.map(([k,v])=>`<tr><td class="cod">${esc(k)}</td><td><div class="barra-h"><span style="width:${(v/max*100).toFixed(1)}%"></span></div></td>
      <td class="num"><b>${eur(v)}</b></td></tr>`).join('')}</tbody></table>`}</div></div>`;
}

function bloqueConsulta(lista){
  const contratos = contratosVisibles();
  const total = lista.reduce((s,i)=>s+importeDe(i),0);
  return `<div class="card" style="margin-bottom:16px"><div class="card-h"><div><h3>Consulta detallada</h3>
    <div class="sub">Filtra lo ejecutado por contrato, carretera o fecha</div></div></div>
    <div class="card-b" style="padding-bottom:0">
      <div style="display:flex;gap:7px;margin-bottom:16px;flex-wrap:wrap;align-items:center">
        <select data-act="filtro-inf-contrato">
          <option value="todos" ${S.infContrato==='todos'?'selected':''}>Todos los contratos</option>
          ${contratos.map(c=>`<option value="${c.id}" ${S.infContrato===c.id?'selected':''}>${esc(c.expediente)} · ${esc(c.nombre)}</option>`).join('')}
        </select>
        <select data-act="filtro-inf-carretera">
          <option value="todos" ${S.infCarretera==='todos'?'selected':''}>Todas las carreteras</option>
          ${db.carreteras.map(r=>`<option ${S.infCarretera===r.nombre?'selected':''}>${esc(r.nombre)}</option>`).join('')}
        </select>
        <label style="font-size:12px;color:var(--gris);display:flex;align-items:center;gap:5px">Desde <input id="inf-desde" type="date" data-act="filtro-inf-fecha" data-tipo="desde" value="${S.infDesde}"></label>
        <label style="font-size:12px;color:var(--gris);display:flex;align-items:center;gap:5px">Hasta <input id="inf-hasta" type="date" data-act="filtro-inf-fecha" data-tipo="hasta" value="${S.infHasta}"></label>
        <span style="margin-left:auto">${cifra('Resultado', lista.length+' imp.', eur(total))}</span>
      </div></div>
    <div class="tabla-wrap">${tablaImputaciones(lista)}</div></div>`;
}

export function vistaInformes(){
  const activos = contratosVisibles(true);
  const lista = imputacionesFiltradas();
  return `<div class="page-head">
    <div><div class="eyebrow">Análisis</div><h1>Informes</h1>
      <p>Comparativa entre contratos, consumo de la anualidad en curso y actividad por carretera y por destino.</p></div>
    <div style="display:flex;gap:8px"><button class="btn btn-s" data-act="descargar" data-t="Informe general en PDF">Informe en PDF</button>
      <button class="btn btn-s" data-act="descargar" data-t="Todos los datos en Excel">Datos en Excel</button></div></div>
  ${bloqueConsulta(lista)}
  <div class="card" style="margin-bottom:16px"><div class="card-h"><div><h3>Consumo por contrato</h3>
    <div class="sub">Grado de ejecución sobre el importe adjudicado</div></div></div>
    <div class="card-b grid" style="gap:20px">${contratosVisibles().map(c=>{const b=balance(c.id);return `<div>
      <div style="display:flex;justify-content:space-between;margin-bottom:7px;flex-wrap:wrap;gap:6px">
        <div><span class="cod">${esc(c.expediente)}</span> <b>${esc(c.nombre)}</b></div>
        <span class="mono" style="color:var(--gris)">${eurK(b.consumido)} / ${eurK(c.adjudicado)}</span></div>
      ${tramo(b)}</div>`;}).join('')}</div></div>
  <div class="card" style="margin-bottom:16px"><div class="card-h"><div><h3>Anualidad ${anioActual}</h3>
    <div class="sub">Consumo frente al tope de gasto presupuestado para el ejercicio</div></div></div>
    <div class="card-b">${activos.map(c=>{const x=balanceAnual(c.id,anioActual);
      return `<div class="anio"><div class="y" style="font-size:12.5px;font-family:'IBM Plex Mono',monospace">${esc(c.expediente)}</div>
        <div>${tramo({pct:x.pct, consumido:x.gasto, saldo:x.saldo, contrato:{adjudicado:x.tope}}, true)}</div>
        <div class="imp"><b>${eurK(x.gasto)}</b><br><span style="color:${x.saldo<0?'var(--rojo)':'var(--gris-claro)'}">${x.saldo<0?'excede '+eurK(-x.saldo):'de '+eurK(x.tope)}</span></div></div>`;}).join('')}
    </div></div>
  <div class="grid g2">${activos.map(c=>`<div class="card">
    <div class="card-h"><div><h3>${esc(c.expediente)}</h3><div class="sub">Curva de gasto acumulado</div></div>
      <button class="btn btn-s" data-act="abrir-contrato" data-id="${c.id}">Ver ficha</button></div>
    <div class="card-b">${graficoAcumulado(c.id)}</div></div>`).join('')}</div>
  ${tablaPorCampo(lista, 'carretera', 'Sin carretera asignada', 'Actividad por carretera', 'Importe imputado sobre cada vía, según los filtros de arriba', 'Carretera')}
  ${tablaPorCampo(lista, 'destino', 'Sin destino asignado', 'Consumo por destino', 'Importe imputado por almacén de destino, según los filtros de arriba', 'Destino')}`;
}

